import { render, staticRenderFns } from "./DigitalAttribution.vue?vue&type=template&id=0156fc16&scoped=true&"
import script from "./DigitalAttribution.vue?vue&type=script&lang=js&"
export * from "./DigitalAttribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156fc16",
  null
  
)

export default component.exports